// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { getProp, resolveColor } from "@insite/mobius/utilities";
import CaretLeft from "@mcmc/XDL/Icons/CaretLeft";
import CaretRight from "@mcmc/XDL/Icons/CaretRight";
import Close from "@mcmc/XDL/Icons/Close";
import { xBaseTheme } from "@mcmc/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        headerColor: "common.background",
        bodyColor: "text.inverse",
        cssOverrides: {
            menu: css`
                height: 100%;
            `,
        },
        childTypographyProps: {
            ellipsis: true,
            transform: "uppercase",
            size: 14,
            weight: "bold",
            css: css`
                display: inline-block;
            `,
        },
        backIconProps: {
            src: CaretLeft,
            size: 16,
            css: css`
                padding: 0;
                margin-right: 8px;
            `,
        },
        closeIconProps: {
            src: Close,
            size: 16,
            css: css`
                padding: 0;
            `,
        },
        panelRowProps: {
            color: "text.inverse",
            moreIconProps: {
                src: CaretRight,
                size: 16,
                css: css`
                    justify-content: flex-end;
                `,
            },

            css: css`
                flex: 0 1 auto;
                min-width: 0;
                padding: 10px 15px;
                &:focus {
                    outline-offset: -${getProp("theme.focus.width", "2px")};
                }

                button {
                    padding: 0;
                }

                & > ${IconWrapper}:only-child {
                    width: 100%;
                }

                ${({ isCurrent, theme }: any) =>
                    isCurrent &&
                    css`
                        & {
                            background: ${resolveColor("primary.contrast", theme)};
                            color: ${resolveColor("text.main", theme)};
                        }
                    `}
            `,
        },
    },
} as xBaseTheme["panelMenu"];
